export default function(ac, app) {
    var valuta = app.getEntity('Valuta');

    valuta.listView()
        .title('Valute')
        .icon('<i class="fa fa-eur fa-3x"></i>')
        .fields([
            ac.field('valuta')
                .cssClasses(['col-md-6']),
            ac.field('sifra')
                .label('Šifra')
                .cssClasses(['col-md-5'])
        ])
        .listActions([
            'edit',
            'delete'
        ]);

    valuta.editionView()
        .title('Valuta')
        .fields([
            {
                key:'valuta',
                type: 'hInput',
                templateOptions: {
                    label: 'Valuta',
                    required: true,
                    focus: true
                }
            },
            {
                key: 'sifra',
                type: 'hInput',
                templateOptions: {
                    label: 'Šifra',
                    required: true
                }
            }
        ]);

    return valuta;
}



// WEBPACK FOOTER //
// ./app/components/valuta/config.js